import { CognitoUserPool } from 'amazon-cognito-identity-js';

// Menu identifiers - use these instead of display labels for activeMenu state
export const MENU_IDS = {
  LIBRARY: 'library',
  RESOURCES: 'resources',
  RECORDINGS: 'recordings',
  UPLOAD: 'upload',
  STREAM: 'stream',
  SIMULATOR: 'simulator',
};

// External URLs
export const PRIVACY_POLICY_URL = 'https://www.talktrees.ai/privacy';
export const PLAYBOOK_URL = 'http://www.talktrees.ai/playbooks';

export const PIPELINE_ID = '2026-talktrees-upload-v1';

// Environment configuration
//
// Defaults are the prod account values. The dev deploy workflow loads talktrees/.env.dev,
// which overrides them with the dev account values.
const env = process.env;

const cognitoPoolData = {
  UserPoolId: env.REACT_APP_COGNITO_USER_POOL_ID || 'us-east-1_JcNQ0Ua6D',
  ClientId: env.REACT_APP_COGNITO_CLIENT_ID || '74k490tr7ua2l114j8nk1fgcc4',
};
export const API_BASE_URL = env.REACT_APP_API_BASE_URL || 'https://api.hatproject.org/';
export const COGNITO_TOKEN_URL =
  env.REACT_APP_COGNITO_TOKEN_URL || 'https://hat-server.auth.us-east-1.amazoncognito.com/oauth2/token';
export const WS_URL = env.REACT_APP_WS_URL || 'wss://ws.hatproject.org/v1aux';

// Create and export the CognitoUserPool instance
export const userPool = new CognitoUserPool(cognitoPoolData);
